import type { CanonGuess } from './types';

export interface CanonMatch {
  entry: CanonGuess;
  matchedAlias?: string; // set when the match came from an alias, for the "·alias" hint
}

function norm(s: string): string {
  return s.toLowerCase().replace(/[^a-z0-9]/g, '');
}

/** Substring search over label + aliases (normalised, punctuation-insensitive).
 *  Excludes ids in `guessed`. Label matches rank above alias matches. */
export function filterCanon(
  canon: readonly CanonGuess[],
  query: string,
  guessed: ReadonlySet<string> = new Set(),
): CanonMatch[] {
  const q = norm(query);
  if (!q) return [];
  const labelHits: CanonMatch[] = [];
  const aliasHits: CanonMatch[] = [];
  for (const entry of canon) {
    if (guessed.has(entry.id)) continue;
    if (norm(entry.label).includes(q)) {
      labelHits.push({ entry });
      continue;
    }
    const alias = entry.aliases.find((a) => norm(a).includes(q));
    if (alias) aliasHits.push({ entry, matchedAlias: alias });
  }
  return [...labelHits, ...aliasHits].slice(0, 8);
}
